/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/anchor-is-valid */
import Loader from 'components/atoms/loader';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { getAppeals, markAppealAsRead } from 'store/modules/monitoring_store/actions';
import TradingMessageAppealItem from 'components/atoms/trading_message_appeals_item';
import { AppealTypes, MonitoringState } from 'store/modules/monitoring_store/types';
import { ProfileState } from 'store/modules/profile_store/types';
import companyId from 'services/company_id';

interface TradingMessageAppealsProps {
  electronicTradingId: number;
}

const TradingMessageAppeals = (props: TradingMessageAppealsProps) => {
  const { electronicTradingId } = props;
  const { monitoring, request } = useSelector<ApplicationState, MonitoringState>(
    (state) => state.storage.monitoring,
  );
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);

  const [appealsList, setAppealsList] = useState<Array<AppealTypes>>([]);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getAppeals(electronicTradingId));
    dispatch(markAppealAsRead(electronicTradingId, companyId(profile)));
  }, []);

  useEffect(() => {
    if (!monitoring.appeals[electronicTradingId]) return;

    setAppealsList(monitoring.appeals[electronicTradingId]);
  }, [monitoring.appeals]);

  return (
    <>
      {request.get_appeals.loading && appealsList?.length === 0 && <Loader />}
      {request.get_appeals.loaded && (
        <>
          <div className="monitoring-bar row m-0 py-2 border-bottom shadow bg-white">
            <div className="col-md-10 d-flex align-items-center">
              <div className="filter-form">
                <strong>Recursos</strong>
                {/* {selectLots}
                {sessions} */}
              </div>
            </div>
            <div className="mt-md-0 mt-2 col-md-2 text-md-right text-center">
              <a
                className="btn btn-outline-secondary"
                href="#"
                id="dLabel"
                role="button"
                onClick={() => dispatch(getAppeals(electronicTradingId))}
              >
                <i className="oi oi-reload" title="Recarregar mensagens" aria-hidden="false" />
              </a>
            </div>
          </div>
          <div className="monitoring-body message-list pl-3 pt-3 pb-5" id="tradingMessage">
            {appealsList?.length === 0 && (
              <div className="d-flex align-items-center text-center h-100">
                <div className="alert alert-light w-100 border" role="alert">
                  <h4 className="alert-heading">Esse pregão ainda não possui recursos.</h4>
                  <p className="mb-0">Você será avisado por e-mail quando tiver um recurso.</p>
                </div>
              </div>
            )}
            {appealsList?.length > 0 &&
              appealsList?.map((appeal, index) => (
                // <TradingMessageAppealItem
                //   key={`trading_item_${index}`}
                //   tradingMessageAppeal={trading_message}
                //   appealNotification={appealNotification}
                // />
                <TradingMessageAppealItem key={`appeal_${index}`} appeal={appeal} />
              ))}
          </div>
        </>
      )}
    </>
  );
};

export default TradingMessageAppeals;
